export default __webpack_public_path__ + "assets/images/ee93727f278feb9b302913bf99948ce3.png";